import * as React from 'react'

import { i18n } from '@thg-commerce/enterprise-core'
import { SafeHtml } from '@thg-commerce/gravity-elements'
import { spacing, styled, Text } from '@thg-commerce/gravity-theme'

const Title = styled.p`
  ${Text('medium1', 'alternate')}
  margin-bottom: ${spacing(2)};
`

const Step = styled(SafeHtml)`
  margin-bottom: ${spacing(2)};
`

const RequiredStep = styled.p`
  ${Text('bodyText', 'default')}
  margin-bottom: ${spacing(2)};
`

export const ReviewInstructions = () => {
  const i18nText = {
    title: i18n('product.reviewinstructions.title'),
    steps: [
      i18n('product.reviewinstructions.instruction1'),
      i18n('product.reviewinstructions.instruction2'),
      i18n('product.reviewinstructions.instruction3'),
    ],
    requiredStep: i18n('product.reviewinstructions.manditoryfield'),
  }

  const steps = i18nText.steps
    .filter((step) => step !== '')
    .map((step, index) => <Step content={step} key={index} />)

  if (!i18nText.title || !i18nText.requiredStep || steps.length === 0) {
    return null
  }

  return (
    <React.Fragment>
      <Title>{i18nText.title}</Title>
      {steps}
      <RequiredStep>{i18nText.requiredStep}</RequiredStep>
    </React.Fragment>
  )
}
